import { FormState, FormStep } from "@components/PatientForms/FormContext/types";
import { weightHistoryValidation, weightHistorySchema } from "@components/PatientForms/categories/WeightHistory";
import { weightTreatmentHistoryValidation, weightTreatmentHistorySchema } from "@components/PatientForms/categories/WeightTreatmentHistory";
import { exerciseHistoryValidation, exerciseHistorySchema } from "@components/PatientForms/categories/ExerciseHistory";
import { eatingHabitsValidation, eatingHabitsSchema } from "@components/PatientForms/categories/EatingHabits";
import { mentalHealthHistoryValidation, mentalHealthHistorySchema } from "@components/PatientForms/categories/MentalHealthHistory";
import { otherWeightManagementHistoryValidation, otherWeightManagementHistorySchema } from "@components/PatientForms/categories/OtherWeightManagementHistory";

export const steps: FormStep[] = [
	{
		id: "weight-history",
		title: "Weight History",
		category: "weightHistory",
		schema: weightHistorySchema,
		validation: weightHistoryValidation,
	},
	{
		id: "weight-treatment-history",
		title: "Weight Treatment History",
		category: "weightTreatmentHistory",
		schema: weightTreatmentHistorySchema,
		validation: weightTreatmentHistoryValidation,
	},
	{
		id: "exercise-history",
		title: "Exercise History",
		category: "exerciseHistory",
		schema: exerciseHistorySchema,
		validation: exerciseHistoryValidation,
	},
	{
		id: "eating-habits",
		title: "Eating Habits",
		category: "eatingHabits",
		schema: eatingHabitsSchema,
		validation: eatingHabitsValidation,
	},
	{
		id: "mental-health-history",
		title: "Mental Health History",
		category: "mentalHealthHistory",
		schema: mentalHealthHistorySchema,
		validation: mentalHealthHistoryValidation,
	},
	{
		id: "additional-medical-history",
		title: "Additional Medical History",
		abbreviation: "Additional Medical History",
		category: "otherWeightManagementHistory",
		schema: otherWeightManagementHistorySchema,
		validation: otherWeightManagementHistoryValidation,
	},
];